import inView from "./controllers/inView";
import parallax from "./controllers/parallax";

document.addEventListener("DOMContentLoaded", function() {
  const loadMoreBtn = document.querySelector('.journal__more');
  const postGrid = document.querySelector('.journal__body');

  if (loadMoreBtn) {
      loadMoreBtn.addEventListener('click', function() {
          const button = this;
          const buttonText = button.querySelector('[button-text]');
          console.log(buttonText);
          // const page = parseInt(button.dataset.page) + 1;
          const offset = parseInt(button.dataset.offset);

          const formData = new FormData();
          formData.append('action', 'load_posts');
          formData.append('offset', offset);
          formData.append('security', loadmore.security);

          fetch(loadmore.url, 
            {
              method: 'POST',
              body: formData
            }
          )
          .then(response => {
            if (response.ok) {
              return response.text();
            }
            throw new Error('Network response was not ok.');
          })
          .then(data => {
            if (data.trim()) {
              // Store the current number of tiles before adding new ones
              const existingTiles = postGrid.querySelectorAll('.journal__tile').length;
              
              // If the trimmed data is not empty, append it to the existing posts
              postGrid.insertAdjacentHTML('beforeend', data);
              
              // Re-initialize GSAP inView for new elements
              inView();

              const parallaxElements = document.querySelectorAll('[data-controller~="opparallax"]');
              const parallaxs = Array.from(parallaxElements).map((element) => new parallax(element));

              // Focus management for keyboard accessibility
              // Find the first newly loaded tile and focus on its first focusable element
              const allTiles = postGrid.querySelectorAll('.journal__tile');
              const firstNewTile = allTiles[existingTiles]; // First tile after existing ones
              
              if (firstNewTile) {
                // Find the first focusable element in the new tile (category link or article button)
                const focusableElement = firstNewTile.querySelector('a, button, [tabindex]:not([tabindex="-1"])');
                if (focusableElement) {
                  // Add a slight delay to ensure DOM is fully updated
                  setTimeout(() => {
                    focusableElement.focus();
                  }, 100);
                }
              }

              buttonText.textContent = 'Load More';
              const newOffset = parseInt(button.dataset.offset) + 7;
              button.dataset.offset = newOffset;

              // Hide button if no more pages
              if (newOffset >= loadmore.max_posts) {
                button.disabled = true;
              }
            } else {
              button.remove(); // if no data, remove the button as well
            }
          })
          .catch(error => {
              console.error('There has been a problem with your fetch operation:', error);
          });

          buttonText.textContent = 'Loading...';
      });
  }
});